"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _webexCore = require("@webex/webex-core");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _utils = require("./utils");
var _constants = require("../constants");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @class BreakoutRequest
 */
var BreakoutRequest = exports.default = /*#__PURE__*/function (_StatelessWebexPlugin) {
  (0, _inherits2.default)(BreakoutRequest, _StatelessWebexPlugin);
  var _super = _createSuper(BreakoutRequest);
  function BreakoutRequest() {
    (0, _classCallCheck2.default)(this, BreakoutRequest);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(BreakoutRequest, [{
    key: "broadcast",
    value:
    /**
     * Broadcast message to all breakout session's participants
     * @param {String} url
     * @param {String} message
     * @param {Object} options
     * @param {string} groupId
     * @param {string} sessionId
     * @returns {Promise}
     */
    function broadcast(_ref) {
      var url = _ref.url,
        message = _ref.message,
        options = _ref.options,
        groupId = _ref.groupId,
        sessionId = _ref.sessionId;
      var roles = (0, _utils.getBroadcastRoles)(options);
      var params = {
        id: groupId,
        recipientRoles: roles.length ? roles : undefined,
        sessions: sessionId ? [{
          id: sessionId
        }] : undefined
      };

      // @ts-ignore
      return this.request({
        method: _constants.HTTP_VERBS.POST,
        uri: "".concat(url, "/message"),
        body: {
          message: message,
          groups: [params]
        }
      }).catch(function (error) {
        if (error.body && error.body.errorCode === 201409036 && error.statusCode === 409) {
          _loggerProxy.default.logger.info("Breakouts#broadcast --> no joined participants");
        } else {
          throw error;
        }
      });
    }
  }]);
  return BreakoutRequest;
}(_webexCore.StatelessWebexPlugin);
//# sourceMappingURL=request.js.map
